import { useTranslation } from "react-i18next";
import Windsurf from "../../Assets/Works/windsurf.webp";
import Lunas from "../../Assets/Works/lunasgrill.webp";
import MilanoBeach from "../../Assets/Works/milanobeach.webp";
import CircuitoLlucmajor from "../../Assets/Works/motosllm.webp";
import MtFitness from "../../Assets/Works/mtfitness.webp";
import SaTravessa from "../../Assets/Works/satravessa.webp";
import Motocross from "../../Assets/Works/motocross.webp";
import NL312 from "../../Assets/Works/312.webp";
import TuroFest from "../../Assets/Works/turo.webp";
import SonMarroig from "../../Assets/Works/sonmarroig.webp";
import AlaireFilms from "../../Assets/Works/alairefilms.webp";
import LCI from "../../Assets/Works/lci.webp";
import AmuntPintures from "../../Assets/Works/amuntpintures.webp";
import Fosh from "../../Assets/Works/fosh.webp";
import Runningfest from "../../Assets/Works/runningfest.webp";
// Logos
import TuroFestLogo from "../../Assets/Clients/turo.webp";
import CircuitoLlucmajorLogo from "../../Assets/Clients/circuitmallorca.webp";
import LunasLogo from "../../Assets/Clients/lunasgrill.webp";
import MilanoBeachLogo from "../../Assets/Clients/milanobeach.webp";
import MtFitnessLogo from "../../Assets/Clients/mtfitness.webp";
import Logo312 from "../../Assets/Clients/312.webp";
import TravessaLogo from "../../Assets/Clients/travessa.webp";
import MotocrossLogo from "../../Assets/Clients/motocross.webp";
import AlaireFilmsLogo from "../../Assets/Clients/alairefilms.webp";
import EmmaKennyLogo from "../../Assets/Clients/emmakenny.webp";
import LCILogo from "../../Assets/Clients/lci.webp";
import AmuntPinturesLogo from "../../Assets/Clients/amuntpintures.webp";
import FoshLogo from "../../Assets/Clients/fosh.webp";
import Rtveib3 from "../../Assets/Clients/rtveib3.webp";


export const useTranslatedVideos = () => {
   const { t } = useTranslation();

   return [
      {
         id: 16,
         videoUrl: "https://www.youtube.com/watch?v=v80VXlwDA6c",
         title: t("works_info.w16.title"),
         desc: t("works_info.w16.desc"),
         slug: "pollenca-running-fest",
         type: "yt",
         logo: Rtveib3,
         fpimg: Runningfest,
      },
      {
         id: 13,
         videoUrl: "https://www.instagram.com/p/DbVvuj9NkwE/",
         title: t("works_info.w13.title"),
         desc: t("works_info.w13.desc"),
         slug: "lci-barcelona",
         type: "insta",
         logo: LCILogo,
         fpimg: LCI,
      },
      {
         id: 12,
         videoUrl: "https://www.instagram.com/p/DZFIyCVoyei/",
         title: t("works_info.w12.title"),
         desc: t("works_info.w12.desc"),
         slug: "turo-fest",
         type: "insta",
         logo: TuroFestLogo,
         fpimg: TuroFest,
      },
      {
         id: 11,
         videoUrl: "https://www.instagram.com/p/DZRvXorDASP/?img_index=1",
         title: t("works_info.w11.title"),
         desc: t("works_info.w11.desc"),
         slug: "son-marroig",
         type: "insta",
         logo: EmmaKennyLogo,
         fpimg: SonMarroig,
      },
      {
         id: 10,
         videoUrl: "https://www.youtube.com/watch?v=snLvg_rH7zQ",
         title: t("works_info.w10.title"),
         desc: t("works_info.w10.desc"),
         slug: "312",
         type: "yt",
         logo: Logo312,
         fpimg: NL312,
      },
      {
         id: 9,
         videoUrl: "https://www.youtube.com/watch?v=a9CnQhBAP7s",
         title: t("works_info.w9.title"),
         desc: t("works_info.w9.desc"),
         slug: "motocross-clubforavilamuro",
         type: "yt",
         logo: MotocrossLogo,
         fpimg: Motocross,
      },
      {
         id: 8,
         videoUrl: "https://www.youtube.com/watch?v=tkd8GHCzKeQ",
         title: t("works_info.w8.title"),
         desc: t("works_info.w8.desc"),
         slug: "travessa",
         type: "yt",
         drone: "Drone FPV + DJI",
         logo: TravessaLogo,
         fpimg: SaTravessa,
      },
      {
         id: 7,
         videoUrl: "https://www.instagram.com/p/DRe96cYDARr/",
         title: t("works_info.w4.title"),
         desc: t("works_info.w4.desc"),
         slug: "inturotel-calador",
         type: "insta",
         drone: "Drone FPV",
         logo: AlaireFilmsLogo,
         fpimg: AlaireFilms,
      },
      {
         id: 15,
         videoUrl: "https://www.instagram.com/p/DJJswWPt8QV/",
         title: t("works_info.w15.title"),
         desc: t("works_info.w15.desc"),
         slug: "fosh-events",
         type: "insta",
         logo: FoshLogo,
         fpimg: Fosh,
      },
      {
         id: 3,
         videoUrl: "https://www.instagram.com/p/DMFYr_sJuw4/",
         title: t("works_info.w3.title"),
         desc: t("works_info.w3.desc"),
         slug: "lunas",
         type: "insta",
         logo: LunasLogo,
         fpimg: Lunas,
      },
      {
         id: 4,
         videoUrl: "https://www.instagram.com/p/DOaugiQiL1d/",
         title: t("works_info.w6.title"),
         desc: t("works_info.w6.desc"),
         slug: "milano-beach",
         type: "insta",
         logo: MilanoBeachLogo,
         fpimg: MilanoBeach,
      },
      {
         id: 14,
         videoUrl: "https://www.instagram.com/p/DXPCBc-jbUA/",
         title: t("works_info.w14.title"),
         desc: t("works_info.w14.desc"),
         slug: "amunt-pintures",
         type: "insta",
         logo: AmuntPinturesLogo,
         fpimg: AmuntPintures,
      },
      {
         id: 5,
         videoUrl: "https://www.instagram.com/p/DLUMz-joyHs/",
         title: t("works_info.w1.title"),
         desc: t("works_info.w1.desc"),
         slug: "circuito-llucmajor",
         type: "insta",
         logo: CircuitoLlucmajorLogo,
         fpimg: CircuitoLlucmajor,
      },
      {
         id: 6,
         videoUrl: "https://www.instagram.com/p/DLWxRRzNhEc/",
         title: t("works_info.w2.title"),
         desc: t("works_info.w2.desc"),
         slug: "mt-fitness",
         type: "insta",
         logo: MtFitnessLogo,
         fpimg: MtFitness,
      },
   ];
};



